
import { defineComponent, ref, computed, onMounted, watch } from 'vue';
import { useRouter } from 'vue-router';
import { usePopupStore } from '@/store/popup'
import { useDicomStore } from '@/store/dicom'
import { useReadingResultStore } from '@/store/readingResult'

export default defineComponent({
  components: {
  },
  props:{
  },
  setup(props, {emit}) {
    const router = useRouter();
    const popupStore = usePopupStore();
    const readingResultStore = useReadingResultStore();

    const closePopup = () => {
      popupStore.togglePopup('completeScore', false);
    }

    const handleConfirmClick = async (): Promise<void> => {
      closePopup();
    }

    onMounted(() => {
    });

    return {
      closePopup,
      handleConfirmClick
    };
  },
});
